angular.module('TetherApp').controller('TwilioCallLogController', [
    '$controller',
    function (
        $controller
    ) {
        let self = this;

        self.participantController = $controller('ParticipantController');
    }
]);
